import * as Yup from "yup";
import formModel from './formModel';

const {
    formField: {
        company_name,
        business_name,
        managerAffinity_mail,
        managerAffinity_name,
        managerAffinity_lastName,
        managerAffinity_phone,
        adviser_phone,
        intermediary_code,
        organizer_code,
        assigned_advisers,
        activated_products,
        model_discount,
        extra_discount,
        commercial_condition,
        commercial_description,
        giftcard_amount,
        business_unit,
    },
} = formModel;

export default [
    Yup.object().shape({
        [activated_products.name]: Yup.array().min(1, activated_products.requiredErrorMsg),
        [assigned_advisers.name]: Yup.array().min(1, assigned_advisers.requiredErrorMsg),
        [company_name.name]: Yup.string()
            .required(`${company_name.requiredErrorMsg}`)
            .matches(/^(?=[a-zA-Z0-9()_+=,.:\s-]*$)/, "Ingrese un nombre válido")
            .max(40, "El nombre ingresado es muy largo"),
        [managerAffinity_lastName.name]: Yup.string()
            .required(`${managerAffinity_lastName.requiredErrorMsg}`)
            .matches(/^(?=[a-zA-Z0-9()_+=,.:\s-]*$)/, "Ingrese un apellido válido")
            .max(40, "El apellido ingresado es muy largo"),
        [managerAffinity_name.name]: Yup.string()
            .required(`${managerAffinity_name.requiredErrorMsg}`)
            .matches(/^(?=[a-zA-Z0-9()_+=,.:\s-]*$)/, "Ingrese un nombre válido")
            .max(40, "El nombre ingresado es muy largo"),
        [business_name.name]: Yup.string()
            .required(`${business_name.requiredErrorMsg}`)
            .matches(/^(?=[a-zA-Z0-9()_+=,.:\s-]*$)/, "Ingrese una razón social válida")
            .max(40, "El nombre ingresado es muy largo"),
        [managerAffinity_mail.name]: Yup.string()
            .required(`${managerAffinity_mail.requiredErrorMsg}`)
            .email("Ingrese un email válido"),
        [managerAffinity_phone.name]: Yup.string()
            .required(`${managerAffinity_phone.requiredErrorMsg}`)
            .matches(/^\(?([0-9]{3,4})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/, "Ingrese un celular válido"),
        [adviser_phone.name]: Yup.string()
            .required(`${adviser_phone.requiredErrorMsg}`)
            .matches(/^\(?([0-9]{3,4})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/, "Ingrese un celular válido"),
        // [company_logo.name]: Yup.string()
        //     .required(`${company_logo.requiredErrorMsg}`),
        [intermediary_code.name]: Yup.number()
            .required(`${intermediary_code.requiredErrorMsg}`)
            .min(200000, "Ingresar 6 números. Deben iniciar con un 2")
            .max(299999, "Ingresar 6 números. Deben iniciar con un 2")
            .integer()
            .typeError("Introduzca únicamente números"),
        [organizer_code.name]: Yup.number()
            .required(`${organizer_code.requiredErrorMsg}`)
            .min(100000, "Ingresar 6 números. Deben iniciar con un 1")
            .max(199999, "Ingresar 6 números. Deben iniciar con un 1")
            .integer()
            .typeError("Introduzca únicamente números"),
        [model_discount.name]: Yup.number()
            .required(`${model_discount.requiredErrorMsg}`)
            .integer()
            .typeError("Introduzca únicamente números"),
        [extra_discount.name]: Yup.number()
            .required(`${extra_discount.requiredErrorMsg}`)
            .integer()
            .typeError("Introduzca únicamente números"),
        [commercial_condition.name]: Yup.string().required(`${commercial_condition.requiredErrorMsg}`),
        [business_unit.name]: Yup.string().required(`${business_unit.requiredErrorMsg}`),
        [giftcard_amount.name]: Yup.string().when([commercial_condition.name], {
            is: 'SI',
            then: Yup.string().test('min_giftcard_amount', 'El monto debe ser superior a cero', amount => {
                return amount > 0;
            }).test('max_giftcard_amount', 'El monto debe ser inferior a $200.000', amount => {
                return amount < 200000;
            }).required(`${giftcard_amount.requiredErrorMsg}`)
        }),
        [commercial_description.name]: Yup.string().when([commercial_condition.name], {
            is: 'SI',
            then: Yup.string().required(`${commercial_description.requiredErrorMsg}`)
        }),

    }),
];